<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Dividend uitkeren aan een aandeelhouder buiten Nederland
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Keert de vennootschap beleggingsdividend uit aan een buitenlandse aandeelhouder die volgens een
                belastingverdrag recht heeft op een vrijstelling van dividendbelasting? Dan mag je die vrijstelling
                onder voorwaarden toepassen.
                <div class="space20"></div>
                Lees meer hierover op de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/winst/dividendbelasting/als_u_dividend_uitkeert/beleggingsdividend_uitkeren_aan_aandeelhouder_buiten_nederland"
                    target="_blank">website van de Belastingdienst.</a>
            </div>
        </div>
    </div>
</div>
